// <tab-trigger class="tab-trigger{% if forloop.first %} active active-mobile{% endif %}" data-tab="tab-{{ tab_handle }}">{{ tab_title }}</tab-trigger>

if(!customElements.get('tab-trigger')) {
  class simpleTabs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('click', (event) => {
        event.preventDefault();

        this.toggleTabs();
      });
    }

    toggleTabs() {
      let siblingTriggers

      const target            = this.dataset.tab
      const tabsNavContainner = this.closest('ul');
      const targetTab         = document.querySelector(`#${target}`);

      if (tabsNavContainner != null) {
        siblingTriggers       = tabsNavContainner.querySelectorAll('.tab-trigger');
      }

      const siblingTabs       = targetTab.closest('.collection-carousel__tabs__body').querySelectorAll('.collection-carousel__tab');

      this.removeClass(siblingTabs)
      this.removeClass(siblingTriggers)

      // Add active class for selected tab
      this.addClass(this);
      this.addClass(targetTab);
    }

    removeClass(selectors) {
      selectors.forEach(selector => {
        selector.classList.remove('active')
      });
    }

    addClass(selector) {
      selector.classList.add('active');
    }
  }

  customElements.define('tab-trigger', simpleTabs);
}
